module.exports = __webpack_public_path__ + "sk-trip-wizard-mockup@2x.f6EiALx8.png";